// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import { deleteOrganisationResponseTransformer, galleyProductResponseTransformer, galleyProductsSearchResponseTransformer, galleyProjectCreateResponseTransformer, galleyProjectResponseTransformer, galleySeasonalEventsResponseTransformer, getEvaluationResponseTransformer, getEvaluationsListResponseTransformer, getOrganisationResponseTransformer, getOrganisationsResponseTransformer, getOrganisationsUsersResponseTransformer, getOrganisationUserApiKeysResponseTransformer, getOrganisationUserResponseTransformer, patchOrganisationResponseTransformer, patchUserResponseTransformer, postChildOrganisationResponseTransformer, postEvaluationResponseTransformer, postOrganisationFileRouteResponseTransformer, postOrganisationResponseTransformer, postOrganisationUserApiKeyResponseTransformer, postUserResponseTransformer, productsSearchResponseTransformer, transferUserOrganisationResponseTransformer, undeleteOrganisationResponseTransformer, updateOrganisationSettingsResponseTransformer, v1GetProductResponseTransformer } from './transformers.gen';
import type { AddOrganisationUsersData, AddOrganisationUsersResponses, AddProjectProductsToAmplifyData, AddProjectProductsToAmplifyErrors, AddProjectProductsToAmplifyResponses, CancelEvaluationData, CancelEvaluationResponses, CreateProductFromManuscriptData, CreateProductFromManuscriptErrors, CreateProductFromManuscriptResponses, DeleteOrganisationData, DeleteOrganisationResponses, DeleteOrganisationUserData, DeleteOrganisationUserResponses, DeleteOrganisationUsersApiKeyData, DeleteOrganisationUsersApiKeyResponses, DeleteProductData, DeleteProductErrors, DeleteProductResponses, ExportOrganizationBooksCsvData, ExportOrganizationBooksCsvErrors, ExportOrganizationBooksCsvResponses, ExportProductsData, ExportProductsResponses, GalleyProductData, GalleyProductErrors, GalleyProductResponses, GalleyProductsSearchData, GalleyProductsSearchErrors, GalleyProductsSearchResponses, GalleyProjectCreateData, GalleyProjectCreateErrors, GalleyProjectCreateResponses, GalleyProjectData, GalleyProjectErrors, GalleyProjectResponses, GalleySeasonalEventsData, GalleySeasonalEventsErrors, GalleySeasonalEventsResponses, GenerateLoginLinkData, GenerateLoginLinkResponses, GenerateProductDescriptionBulkData, GenerateProductDescriptionBulkResponses, GenerateProductDescriptionData, GenerateProductDescriptionResponses, GenerateProductKeywordsBulkData, GenerateProductKeywordsBulkResponses, GenerateProductKeywordsData, GenerateProductKeywordsResponses, GenerateProductManuscriptAnalysisData, GenerateProductManuscriptAnalysisErrors, GenerateProductManuscriptAnalysisResponses, GenerateProductSubtitleData, GenerateProductSubtitleResponses, GenerateProductThemaBulkData, GenerateProductThemaBulkResponses, GenerateProductThemaData, GenerateProductThemaResponses, GetBisacCodesData, GetBisacCodesErrors, GetBisacCodesResponses, GetBookSalesInfoRouteData, GetBookSalesInfoRouteErrors, GetBookSalesInfoRouteResponses, GetBookSalesRouteData, GetBookSalesRouteErrors, GetBookSalesRouteResponses, GetEvaluationData, GetEvaluationResponses, GetEvaluationsListData, GetEvaluationsListResponses, GetFileData, GetFileResponses, GetOrganisationData, GetOrganisationResponses, GetOrganisationsData, GetOrganisationsResponses, GetOrganisationsUsersData, GetOrganisationsUsersResponses, GetOrganisationUserApiKeysData, GetOrganisationUserApiKeysResponses, GetOrganisationUserData, GetOrganisationUserResponses, GetProductAcpFeedPreviewData, GetProductAcpFeedPreviewErrors, GetProductAcpFeedPreviewResponses, GetProductAmplifyAPlusContentData, GetProductAmplifyAPlusContentErrors, GetProductAmplifyAPlusContentResponses, GetProductRawData, GetProductRawErrors, GetProductRawResponses, GetThemaCodesData, GetThemaCodesResponses, GetUserData, GetUserResponses, HealthData, HealthResponses, ListProductsAmplifySummariesData, ListProductsAmplifySummariesErrors, ListProductsAmplifySummariesResponses, PatchOrganisationData, PatchOrganisationResponses, PatchUserData, PatchUserResponses, PostAcpExportData, PostAcpExportErrors, PostAcpExportResponses, PostChildOrganisationData, PostChildOrganisationResponses, PostEvaluationData, PostEvaluationResponses, PostOnixImportReportScheduleData, PostOnixImportReportScheduleErrors, PostOnixImportReportScheduleResponses, PostOrganisationData, PostOrganisationFileRouteData, PostOrganisationFileRouteResponses, PostOrganisationResponses, PostOrganisationUserApiKeyData, PostOrganisationUserApiKeyResponses, PostUserData, PostUserResponses, ProductsSearchData, ProductsSearchErrors, ProductsSearchResponses, SearchBisacData, SearchBisacErrors, SearchBisacResponses, SearchThemaData, SearchThemaResponses, TransferUserOrganisationData, TransferUserOrganisationResponses, UndeleteOrganisationData, UndeleteOrganisationResponses, UpdateOrganisationSettingsData, UpdateOrganisationSettingsResponses, UpdateProductFinalKeywordsData, UpdateProductFinalKeywordsResponses, UpsertProductKeywordFeedbackData, UpsertProductKeywordFeedbackResponses, V1GetBlurbData, V1GetBlurbResponses, V1GetKeywordsData, V1GetKeywordsResponses, V1GetProductData, V1GetProductErrors, V1GetProductResponses, V1PostBlurbData, V1PostBlurbResponses, V1PostKeywordsData, V1PostKeywordsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * System health check
 *
 * Health check route that returns 200 if all ok
 */
export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>): RequestResult<HealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthResponses, unknown, ThrowOnError>({ url: '/health', ...options });

/**
 * Products Search
 *
 * Search products using Elasticsearch with optional semantic or hybrid search
 */
export const productsSearch = <ThrowOnError extends boolean = false>(options?: Options<ProductsSearchData, ThrowOnError>): RequestResult<ProductsSearchResponses, ProductsSearchErrors, ThrowOnError> => (options?.client ?? client).post<ProductsSearchResponses, ProductsSearchErrors, ThrowOnError>({
    responseTransformer: productsSearchResponseTransformer,
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/search/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get Thema-Codes
 *
 * Get Thema-Codes - either root codes or children of a parent code for hierarchical navigation
 */
export const getThemaCodes = <ThrowOnError extends boolean = false>(options?: Options<GetThemaCodesData, ThrowOnError>): RequestResult<GetThemaCodesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetThemaCodesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/thema/codes',
    ...options
});

/**
 * Search Thema-Codes
 *
 * Search for Thema-Codes by query string
 */
export const searchThema = <ThrowOnError extends boolean = false>(options: Options<SearchThemaData, ThrowOnError>): RequestResult<SearchThemaResponses, unknown, ThrowOnError> => (options.client ?? client).get<SearchThemaResponses, unknown, ThrowOnError>({
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/thema/search',
    ...options
});

/**
 * Get BISAC codes
 *
 * Get every BISAC code of the ingested edition in BISAC source order
 */
export const getBisacCodes = <ThrowOnError extends boolean = false>(options?: Options<GetBisacCodesData, ThrowOnError>): RequestResult<GetBisacCodesResponses, GetBisacCodesErrors, ThrowOnError> => (options?.client ?? client).get<GetBisacCodesResponses, GetBisacCodesErrors, ThrowOnError>({
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/bisac/codes',
    ...options
});

/**
 * Search BISAC codes
 *
 * Get every BISAC code whose notation starts with the query, then every code whose heading contains all its terms, each group in BISAC source order
 */
export const searchBisac = <ThrowOnError extends boolean = false>(options: Options<SearchBisacData, ThrowOnError>): RequestResult<SearchBisacResponses, SearchBisacErrors, ThrowOnError> => (options.client ?? client).get<SearchBisacResponses, SearchBisacErrors, ThrowOnError>({
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/bisac/search',
    ...options
});

/**
 * Get all child organisations
 *
 * Gets child organisation
 */
export const getOrganisations = <ThrowOnError extends boolean = false>(options?: Options<GetOrganisationsData, ThrowOnError>): RequestResult<GetOrganisationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetOrganisationsResponses, unknown, ThrowOnError>({
    responseTransformer: getOrganisationsResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisations',
    ...options
});

/**
 * Mark organisation as deleted
 *
 * Marks the organisation as deleted using identifier
 */
export const deleteOrganisation = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganisationData, ThrowOnError>): RequestResult<DeleteOrganisationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteOrganisationResponses, unknown, ThrowOnError>({
    responseTransformer: deleteOrganisationResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}',
    ...options
});

/**
 * Get organisation
 *
 * Gets child organisation
 */
export const getOrganisation = <ThrowOnError extends boolean = false>(options: Options<GetOrganisationData, ThrowOnError>): RequestResult<GetOrganisationResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetOrganisationResponses, unknown, ThrowOnError>({
    responseTransformer: getOrganisationResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}',
    ...options
});

/**
 * Update organisation
 *
 * Updates child organisation from given inputs
 */
export const patchOrganisation = <ThrowOnError extends boolean = false>(options: Options<PatchOrganisationData, ThrowOnError>): RequestResult<PatchOrganisationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchOrganisationResponses, unknown, ThrowOnError>({
    responseTransformer: patchOrganisationResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create organisation
 *
 * Creates child organisation from given inputs
 */
export const postChildOrganisation = <ThrowOnError extends boolean = false>(options: Options<PostChildOrganisationData, ThrowOnError>): RequestResult<PostChildOrganisationResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostChildOrganisationResponses, unknown, ThrowOnError>({
    responseTransformer: postChildOrganisationResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Undelete organisation
 *
 * Restores a previously deleted organisation
 */
export const undeleteOrganisation = <ThrowOnError extends boolean = false>(options: Options<UndeleteOrganisationData, ThrowOnError>): RequestResult<UndeleteOrganisationResponses, unknown, ThrowOnError> => (options.client ?? client).post<UndeleteOrganisationResponses, unknown, ThrowOnError>({
    responseTransformer: undeleteOrganisationResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/undelete',
    ...options
});

/**
 * Create organisation
 *
 * Creates a new organisation from given inputs
 */
export const postOrganisation = <ThrowOnError extends boolean = false>(options?: Options<PostOrganisationData, ThrowOnError>): RequestResult<PostOrganisationResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostOrganisationResponses, unknown, ThrowOnError>({
    responseTransformer: postOrganisationResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Update organisation settings
 *
 * Updates the settings for an organisation with only the provided fields
 */
export const updateOrganisationSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganisationSettingsData, ThrowOnError>): RequestResult<UpdateOrganisationSettingsResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateOrganisationSettingsResponses, unknown, ThrowOnError>({
    responseTransformer: updateOrganisationSettingsResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all child organisation users
 *
 * Gets child organisation users
 */
export const getOrganisationsUsers = <ThrowOnError extends boolean = false>(options: Options<GetOrganisationsUsersData, ThrowOnError>): RequestResult<GetOrganisationsUsersResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetOrganisationsUsersResponses, unknown, ThrowOnError>({
    responseTransformer: getOrganisationsUsersResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/users',
    ...options
});

/**
 * Add a list of users to an organisation
 *
 * Add a list of users to an organisation
 */
export const addOrganisationUsers = <ThrowOnError extends boolean = false>(options: Options<AddOrganisationUsersData, ThrowOnError>): RequestResult<AddOrganisationUsersResponses, unknown, ThrowOnError> => (options.client ?? client).post<AddOrganisationUsersResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create organisation user
 *
 * Creates child organisation user from given inputs
 */
export const postUser = <ThrowOnError extends boolean = false>(options: Options<PostUserData, ThrowOnError>): RequestResult<PostUserResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostUserResponses, unknown, ThrowOnError>({
    responseTransformer: postUserResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a user
 *
 * Deletes a user entirely from Reedy
 */
export const deleteOrganisationUser = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganisationUserData, ThrowOnError>): RequestResult<DeleteOrganisationUserResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteOrganisationUserResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/user/{useridentifier}',
    ...options
});

/**
 * Get organisation user
 *
 * Gets child organisation user
 */
export const getOrganisationUser = <ThrowOnError extends boolean = false>(options: Options<GetOrganisationUserData, ThrowOnError>): RequestResult<GetOrganisationUserResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetOrganisationUserResponses, unknown, ThrowOnError>({
    responseTransformer: getOrganisationUserResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/user/{useridentifier}',
    ...options
});

/**
 * Update organisation user
 *
 * Updates child organisation user from given inputs
 */
export const patchUser = <ThrowOnError extends boolean = false>(options: Options<PatchUserData, ThrowOnError>): RequestResult<PatchUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchUserResponses, unknown, ThrowOnError>({
    responseTransformer: patchUserResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/user/{useridentifier}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transfer user to another organisation
 *
 * Moves a user from their current organisation to a specified destination organisation
 */
export const transferUserOrganisation = <ThrowOnError extends boolean = false>(options: Options<TransferUserOrganisationData, ThrowOnError>): RequestResult<TransferUserOrganisationResponses, unknown, ThrowOnError> => (options.client ?? client).post<TransferUserOrganisationResponses, unknown, ThrowOnError>({
    responseTransformer: transferUserOrganisationResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{source_id}/user/{useridentifier}/transfer/{destination_id}',
    ...options
});

/**
 * Get all child organisation user api keys
 *
 * Gets child organisation users api keys
 */
export const getOrganisationUserApiKeys = <ThrowOnError extends boolean = false>(options: Options<GetOrganisationUserApiKeysData, ThrowOnError>): RequestResult<GetOrganisationUserApiKeysResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetOrganisationUserApiKeysResponses, unknown, ThrowOnError>({
    responseTransformer: getOrganisationUserApiKeysResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/user/{useridentifier}/api-keys',
    ...options
});

/**
 * Create organisation user api-key
 *
 * Creates child organisation user api-key
 */
export const postOrganisationUserApiKey = <ThrowOnError extends boolean = false>(options: Options<PostOrganisationUserApiKeyData, ThrowOnError>): RequestResult<PostOrganisationUserApiKeyResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostOrganisationUserApiKeyResponses, unknown, ThrowOnError>({
    responseTransformer: postOrganisationUserApiKeyResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/user/{useridentifier}/api-key',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete the organisation user api key
 *
 * Delete organisation user api key using identifier
 */
export const deleteOrganisationUsersApiKey = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganisationUsersApiKeyData, ThrowOnError>): RequestResult<DeleteOrganisationUsersApiKeyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteOrganisationUsersApiKeyResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/user/{useridentifier}/api-key/{apikeyidentifier}',
    ...options
});

/**
 * Create organisation file
 *
 * Creates organisation file from given inputs
 */
export const postOrganisationFileRoute = <ThrowOnError extends boolean = false>(options: Options<PostOrganisationFileRouteData, ThrowOnError>): RequestResult<PostOrganisationFileRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostOrganisationFileRouteResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseTransformer: postOrganisationFileRouteResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/file/{file_name}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Schedule ACP feed export
 *
 * Creates an ACP export request and schedules a Cloud Task to generate the JSONL feed.
 */
export const postAcpExport = <ThrowOnError extends boolean = false>(options: Options<PostAcpExportData, ThrowOnError>): RequestResult<PostAcpExportResponses, PostAcpExportErrors, ThrowOnError> => (options.client ?? client).post<PostAcpExportResponses, PostAcpExportErrors, ThrowOnError>({
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/account/organisation/{identifier}/acp-export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve all evaluations
 *
 * Retrieve evaluations generation results
 */
export const getEvaluationsList = <ThrowOnError extends boolean = false>(options?: Options<GetEvaluationsListData, ThrowOnError>): RequestResult<GetEvaluationsListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetEvaluationsListResponses, unknown, ThrowOnError>({
    responseTransformer: getEvaluationsListResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/evaluations',
    ...options
});

/**
 * Generate an evaluation
 *
 * Generates evaluation from given inputs
 */
export const postEvaluation = <ThrowOnError extends boolean = false>(options?: Options<PostEvaluationData, ThrowOnError>): RequestResult<PostEvaluationResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostEvaluationResponses, unknown, ThrowOnError>({
    responseTransformer: postEvaluationResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/evaluation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retrieve evaluation
 *
 * Retrieve evaluation generation result using identifier
 */
export const getEvaluation = <ThrowOnError extends boolean = false>(options: Options<GetEvaluationData, ThrowOnError>): RequestResult<GetEvaluationResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetEvaluationResponses, unknown, ThrowOnError>({
    responseTransformer: getEvaluationResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/evaluation/{identifier}',
    ...options
});

/**
 * Cancel evaluation
 *
 * Cancel in progress evaluation by identifier
 */
export const cancelEvaluation = <ThrowOnError extends boolean = false>(options: Options<CancelEvaluationData, ThrowOnError>): RequestResult<CancelEvaluationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<CancelEvaluationResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/evaluation/{identifier}/cancel',
    ...options
});

/**
 * Get raw product data
 *
 * Returns the productsImport document for a product as raw section dumps (header, baseProduct, rawOnixV3). Field names match the Firestore schema verbatim - no fields are renamed or dropped. Superadmin only.
 */
export const getProductRaw = <ThrowOnError extends boolean = false>(options: Options<GetProductRawData, ThrowOnError>): RequestResult<GetProductRawResponses, GetProductRawErrors, ThrowOnError> => (options.client ?? client).get<GetProductRawResponses, GetProductRawErrors, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/raw',
    ...options
});

/**
 * Get product ACP feed preview
 *
 * Return the schema-aligned OpenAI commerce product preview for a product.
 */
export const getProductAcpFeedPreview = <ThrowOnError extends boolean = false>(options: Options<GetProductAcpFeedPreviewData, ThrowOnError>): RequestResult<GetProductAcpFeedPreviewResponses, GetProductAcpFeedPreviewErrors, ThrowOnError> => (options.client ?? client).get<GetProductAcpFeedPreviewResponses, GetProductAcpFeedPreviewErrors, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/acp-feed-preview',
    ...options
});

/**
 * Get Amplify A+ content status
 *
 * Return the Amazon A+ content status for a product as reported by Amplify, looked up by the Reedy product id. A status of unknown means the product maps to no ASIN; a failure is never reported as none. See docs/amplify-integration.md.
 */
export const getProductAmplifyAPlusContent = <ThrowOnError extends boolean = false>(options: Options<GetProductAmplifyAPlusContentData, ThrowOnError>): RequestResult<GetProductAmplifyAPlusContentResponses, GetProductAmplifyAPlusContentErrors, ThrowOnError> => (options.client ?? client).get<GetProductAmplifyAPlusContentResponses, GetProductAmplifyAPlusContentErrors, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/amplify/a-plus-content',
    ...options
});

/**
 * Get Amplify summaries of products
 *
 * Return Amplify's summary of each product, looked up by the Reedy product id. A failure is never reported as a product without A+ content. See docs/amplify-integration.md.
 */
export const listProductsAmplifySummaries = <ThrowOnError extends boolean = false>(options?: Options<ListProductsAmplifySummariesData, ThrowOnError>): RequestResult<ListProductsAmplifySummariesResponses, ListProductsAmplifySummariesErrors, ThrowOnError> => (options?.client ?? client).post<ListProductsAmplifySummariesResponses, ListProductsAmplifySummariesErrors, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/products/amplify/summaries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Generate product keywords
 *
 * Generate product keywords
 */
export const generateProductKeywords = <ThrowOnError extends boolean = false>(options: Options<GenerateProductKeywordsData, ThrowOnError>): RequestResult<GenerateProductKeywordsResponses, unknown, ThrowOnError> => (options.client ?? client).post<GenerateProductKeywordsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/generation/keywords',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate bulk product keywords
 *
 * Generate bulk product keywords
 */
export const generateProductKeywordsBulk = <ThrowOnError extends boolean = false>(options?: Options<GenerateProductKeywordsBulkData, ThrowOnError>): RequestResult<GenerateProductKeywordsBulkResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GenerateProductKeywordsBulkResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/products/generation/keywords',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Generate product description
 *
 * Generate product description
 */
export const generateProductDescription = <ThrowOnError extends boolean = false>(options: Options<GenerateProductDescriptionData, ThrowOnError>): RequestResult<GenerateProductDescriptionResponses, unknown, ThrowOnError> => (options.client ?? client).post<GenerateProductDescriptionResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/generation/description',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate bulk product description
 *
 * Generate bulk product description
 */
export const generateProductDescriptionBulk = <ThrowOnError extends boolean = false>(options?: Options<GenerateProductDescriptionBulkData, ThrowOnError>): RequestResult<GenerateProductDescriptionBulkResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GenerateProductDescriptionBulkResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/products/generation/description',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Generate product thema
 *
 * Generate product thema
 */
export const generateProductThema = <ThrowOnError extends boolean = false>(options: Options<GenerateProductThemaData, ThrowOnError>): RequestResult<GenerateProductThemaResponses, unknown, ThrowOnError> => (options.client ?? client).post<GenerateProductThemaResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/generation/thema',
    ...options
});

/**
 * Generate bulk product thema
 *
 * Generate bulk product thema
 */
export const generateProductThemaBulk = <ThrowOnError extends boolean = false>(options?: Options<GenerateProductThemaBulkData, ThrowOnError>): RequestResult<GenerateProductThemaBulkResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GenerateProductThemaBulkResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/products/generation/thema',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Generate product subtitle
 *
 * Generate product subtitle
 */
export const generateProductSubtitle = <ThrowOnError extends boolean = false>(options: Options<GenerateProductSubtitleData, ThrowOnError>): RequestResult<GenerateProductSubtitleResponses, unknown, ThrowOnError> => (options.client ?? client).post<GenerateProductSubtitleResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/generation/subtitle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate manuscript analysis
 *
 * Generate analysis for a product's manuscript
 */
export const generateProductManuscriptAnalysis = <ThrowOnError extends boolean = false>(options: Options<GenerateProductManuscriptAnalysisData, ThrowOnError>): RequestResult<GenerateProductManuscriptAnalysisResponses, GenerateProductManuscriptAnalysisErrors, ThrowOnError> => (options.client ?? client).post<GenerateProductManuscriptAnalysisResponses, GenerateProductManuscriptAnalysisErrors, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/generation/analysis',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export products to ONIX
 *
 * Export products to ONIX
 */
export const exportProducts = <ThrowOnError extends boolean = false>(options?: Options<ExportProductsData, ThrowOnError>): RequestResult<ExportProductsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ExportProductsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/products/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Export selected books as CSV
 *
 * Export selected books as a CSV file containing database keywords, final keywords, database description, and final description.
 */
export const exportOrganizationBooksCsv = <ThrowOnError extends boolean = false>(options?: Options<ExportOrganizationBooksCsvData, ThrowOnError>): RequestResult<ExportOrganizationBooksCsvResponses, ExportOrganizationBooksCsvErrors, ThrowOnError> => (options?.client ?? client).post<ExportOrganizationBooksCsvResponses, ExportOrganizationBooksCsvErrors, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/products/export-csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Upload manuscript with minimal product data
 *
 * Creates a minimal product entry with just a manuscript upload. Products created with this endpoint will be marked with sourceType=MANUSCRIPT_ONLY.
 */
export const createProductFromManuscript = <ThrowOnError extends boolean = false>(options?: Options<CreateProductFromManuscriptData, ThrowOnError>): RequestResult<CreateProductFromManuscriptResponses, CreateProductFromManuscriptErrors, ThrowOnError> => (options?.client ?? client).post<CreateProductFromManuscriptResponses, CreateProductFromManuscriptErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/manuscript-upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Delete a product
 *
 * Delete a product that is MANUSCRIPT_ONLY
 */
export const deleteProduct = <ThrowOnError extends boolean = false>(options: Options<DeleteProductData, ThrowOnError>): RequestResult<DeleteProductResponses, DeleteProductErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProductResponses, DeleteProductErrors, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}',
    ...options
});

/**
 * Update final keywords
 *
 * Update the final keyword phrases and automatically derive single words
 */
export const updateProductFinalKeywords = <ThrowOnError extends boolean = false>(options: Options<UpdateProductFinalKeywordsData, ThrowOnError>): RequestResult<UpdateProductFinalKeywordsResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateProductFinalKeywordsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/keywords/final',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit or update keyword feedback (thumbs-down + optional categorization)
 *
 * Logs a thumbs-down on a keyword. The client supplies the UUID; first call returns 201, subsequent calls with the same id return 200 and overwrite the document.
 */
export const upsertProductKeywordFeedback = <ThrowOnError extends boolean = false>(options: Options<UpsertProductKeywordFeedbackData, ThrowOnError>): RequestResult<UpsertProductKeywordFeedbackResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpsertProductKeywordFeedbackResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/product/{product_id}/keywords/feedback/{feedback_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add project products to Amplify
 *
 * Add products of a Reedy project to the project's Amplify project. The first call creates the Amplify project; products already in it are skipped. See docs/amplify-integration.md.
 */
export const addProjectProductsToAmplify = <ThrowOnError extends boolean = false>(options: Options<AddProjectProductsToAmplifyData, ThrowOnError>): RequestResult<AddProjectProductsToAmplifyResponses, AddProjectProductsToAmplifyErrors, ThrowOnError> => (options.client ?? client).post<AddProjectProductsToAmplifyResponses, AddProjectProductsToAmplifyErrors, ThrowOnError>({
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/projects/{project_id}/amplify/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a user
 *
 * Gets a users profile
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>): RequestResult<GetUserResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetUserResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/users/{user_id}',
    ...options
});

/**
 * Generate a login link for a user
 *
 * Creates a login link for a user
 */
export const generateLoginLink = <ThrowOnError extends boolean = false>(options: Options<GenerateLoginLinkData, ThrowOnError>): RequestResult<GenerateLoginLinkResponses, unknown, ThrowOnError> => (options.client ?? client).get<GenerateLoginLinkResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/users/{user_id}/login-link',
    ...options
});

/**
 * Retrieve a file
 *
 * Retrieve a file from storage
 */
export const getFile = <ThrowOnError extends boolean = false>(options: Options<GetFileData, ThrowOnError>): RequestResult<GetFileResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetFileResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/files/{file_type}/{file_name}',
    ...options
});

/**
 * Schedule ONIX import report export
 *
 * Schedules background generation of an ONIX import CSV report via Cloud Task and returns the report identifier.
 */
export const postOnixImportReportSchedule = <ThrowOnError extends boolean = false>(options?: Options<PostOnixImportReportScheduleData, ThrowOnError>): RequestResult<PostOnixImportReportScheduleResponses, PostOnixImportReportScheduleErrors, ThrowOnError> => (options?.client ?? client).post<PostOnixImportReportScheduleResponses, PostOnixImportReportScheduleErrors, ThrowOnError>({
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/reports/onix-imports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Book sales time series
 *
 * Per-bucket sales series for one book over a date range and granularity. `type=market` (default) returns per-market units and native-currency revenue from the org's sales panel; `type=amazon` returns Amazon ordered units, revenue, page views, conversion rate and Best Sellers Rank, plus window totals and the Amazon share of the market panel's units. Revenue is never converted across currencies.
 */
export const getBookSalesRoute = <ThrowOnError extends boolean = false>(options: Options<GetBookSalesRouteData, ThrowOnError>): RequestResult<GetBookSalesRouteResponses, GetBookSalesRouteErrors, ThrowOnError> => (options.client ?? client).get<GetBookSalesRouteResponses, GetBookSalesRouteErrors, ThrowOnError>({
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/books/sales',
    ...options
});

/**
 * Book sales info
 *
 * Window-independent sales metadata for one book, over all history. `market` is the first industry-panel date across the selected ISBNs and `amazon` is the first Amazon ordered-sales date (pre-orders included); both anchor the date picker and the pre-order banner. `markets` is the distinct set of markets the selected ISBNs have sold into, ordered with the org's home marketplace first then alphabetically, so the client can order its chart and summary cards directly from it.
 */
export const getBookSalesInfoRoute = <ThrowOnError extends boolean = false>(options: Options<GetBookSalesInfoRouteData, ThrowOnError>): RequestResult<GetBookSalesInfoRouteResponses, GetBookSalesInfoRouteErrors, ThrowOnError> => (options.client ?? client).get<GetBookSalesInfoRouteResponses, GetBookSalesInfoRouteErrors, ThrowOnError>({
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/books/sales/info',
    ...options
});

/**
 * Galley Products Search
 *
 * Search products for the Galley agent, one hit per work. Organisations with a dedicated index get Essence-aware hybrid search; all others get the default semantic search with empty Essence parts.
 */
export const galleyProductsSearch = <ThrowOnError extends boolean = false>(options?: Options<GalleyProductsSearchData, ThrowOnError>): RequestResult<GalleyProductsSearchResponses, GalleyProductsSearchErrors, ThrowOnError> => (options?.client ?? client).post<GalleyProductsSearchResponses, GalleyProductsSearchErrors, ThrowOnError>({
    responseTransformer: galleyProductsSearchResponseTransformer,
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/galley/search/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Galley Book
 *
 * The book view for the Galley agent: catalog fields and full Essence data, read from the organisation's dedicated index. Organisations without a dedicated index get 404.
 */
export const galleyProduct = <ThrowOnError extends boolean = false>(options: Options<GalleyProductData, ThrowOnError>): RequestResult<GalleyProductResponses, GalleyProductErrors, ThrowOnError> => (options.client ?? client).get<GalleyProductResponses, GalleyProductErrors, ThrowOnError>({
    responseTransformer: galleyProductResponseTransformer,
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/galley/products/{product_id}',
    ...options
});

/**
 * Galley Seasonal Events
 *
 * Upcoming seasonal events for the Galley agent, as stored by the seasonal event pipeline: the next occurrence of each event, its lead time, categories, description, evidence, and search prompts. International events are always included.
 */
export const galleySeasonalEvents = <ThrowOnError extends boolean = false>(options?: Options<GalleySeasonalEventsData, ThrowOnError>): RequestResult<GalleySeasonalEventsResponses, GalleySeasonalEventsErrors, ThrowOnError> => (options?.client ?? client).get<GalleySeasonalEventsResponses, GalleySeasonalEventsErrors, ThrowOnError>({
    responseTransformer: galleySeasonalEventsResponseTransformer,
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/galley/seasonal-events',
    ...options
});

/**
 * Galley Project Create
 *
 * Create a Reedy project of the organisation's products for the Galley agent, as the project editor in Reedy does. Duplicate product ids are removed. The project opens at /projects/<id>.
 */
export const galleyProjectCreate = <ThrowOnError extends boolean = false>(options?: Options<GalleyProjectCreateData, ThrowOnError>): RequestResult<GalleyProjectCreateResponses, GalleyProjectCreateErrors, ThrowOnError> => (options?.client ?? client).post<GalleyProjectCreateResponses, GalleyProjectCreateErrors, ThrowOnError>({
    responseTransformer: galleyProjectCreateResponseTransformer,
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/galley/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Galley Project
 *
 * A Reedy project of the organisation for the Galley agent, with its books in project order.
 */
export const galleyProject = <ThrowOnError extends boolean = false>(options: Options<GalleyProjectData, ThrowOnError>): RequestResult<GalleyProjectResponses, GalleyProjectErrors, ThrowOnError> => (options.client ?? client).get<GalleyProjectResponses, GalleyProjectErrors, ThrowOnError>({
    responseTransformer: galleyProjectResponseTransformer,
    security: [{
            key: 'firebaseAccessToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/galley/projects/{project_id}',
    ...options
});

/**
 * Generate blurb
 *
 * Generates blurb from given inputs
 */
export const v1PostBlurb = <ThrowOnError extends boolean = false>(options?: Options<V1PostBlurbData, ThrowOnError>): RequestResult<V1PostBlurbResponses, unknown, ThrowOnError> => (options?.client ?? client).post<V1PostBlurbResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/metadata/blurb',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retrieve blurb
 *
 * Retrieve blurb generation result using identifier
 */
export const v1GetBlurb = <ThrowOnError extends boolean = false>(options: Options<V1GetBlurbData, ThrowOnError>): RequestResult<V1GetBlurbResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1GetBlurbResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/metadata/blurb/{identifier}',
    ...options
});

/**
 * Generate keywords
 *
 * Generates keywords from given inputs
 */
export const v1PostKeywords = <ThrowOnError extends boolean = false>(options?: Options<V1PostKeywordsData, ThrowOnError>): RequestResult<V1PostKeywordsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<V1PostKeywordsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/metadata/keywords',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retrieve keywords
 *
 * Retrieve keywords generation result using identifier
 */
export const v1GetKeywords = <ThrowOnError extends boolean = false>(options: Options<V1GetKeywordsData, ThrowOnError>): RequestResult<V1GetKeywordsResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1GetKeywordsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/metadata/keywords/{identifier}',
    ...options
});

/**
 * Retrieve product
 *
 * Returns the full product document as stored in Firestore. Only products belonging to the caller's organisation are accessible; anything else is reported as not found.
 */
export const v1GetProduct = <ThrowOnError extends boolean = false>(options: Options<V1GetProductData, ThrowOnError>): RequestResult<V1GetProductResponses, V1GetProductErrors, ThrowOnError> => (options.client ?? client).get<V1GetProductResponses, V1GetProductErrors, ThrowOnError>({
    responseTransformer: v1GetProductResponseTransformer,
    security: [{
            key: 'apiKey',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/products/{product_id}',
    ...options
});
